module.exports = __webpack_public_path__ + "static/media/AlternateGotNo2D-01.6ddcc2e7.svg";